export enum ETipoCaracteristica {
    TextoLivre = 1,
    Numero = 2,
    Decimal = 3,
    ListaSimples = 4,
    ListaSubItens = 5,
    Cor = 6
}
